import InteractiveGraphicView from './components/InteractiveGraphicView/InteractiveGraphicView';
import FlatsTable from './components/FlatsSidebar/FlatsSidebar';
import { FlatsDataProvider } from './contexts/FlatsDataContext';
import { SVGProvider } from './contexts/GraphicContext';

import './App.css';

function App() {
  return (
    <div className="App">
        <FlatsDataProvider>
            <SVGProvider>
                <div className="pane-wrapper">
                    <InteractiveGraphicView />
                    <FlatsTable />
                </div>
            </SVGProvider>
        </FlatsDataProvider>
    </div>
);
}

export default App;